import React, { useState } from "react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import Ch2 from "./Ch2";
import Ch3 from "./Ch3";
import MediaQuery from "react-responsive";
import { Scrollbar } from "react-scrollbars-custom";
import Chtambahan from "./Chtambahan";
import "../1/Part1.css"

const Part3 = () => {
	const [chsoal0, setChsoal0] = useState(false);
	const clickSetChSoal0 = () => setChsoal0(!chsoal0);
	const [chsoal1, setChsoal1] = useState(false);
	const clickSetChSoal1 = () => setChsoal1(!chsoal1);
	const [jawaban1, setJawaban1] = useState(false);
	const clickSetJawaban1 = () => setJawaban1(!jawaban1);
	const [chsoal2, setChsoal2] = useState(false);
	const clickSetChSoal2 = () => setChsoal2(!chsoal2);
	const [chsoal3, setChsoal3] = useState(false);
	const clickSetChSoal3 = () => setChsoal3(!chsoal3);

	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);
	const [show11, setShow11] = useState(false);
	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "70px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "70px", height: "30px" });
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });
	const [form9, setForm9] = useState({ width: "50px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "50px", height: "30px" });
	const [form12, setForm12] = useState({ width: "50px", height: "30px" });
	const [form13, setForm13] = useState({ width: "50px", height: "30px" });
	const [form14, setForm14] = useState({ width: "50px", height: "30px" });
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		jwb === "50"
			? setForm1({
					border: "6px solid #1aff66",
					width: "50px",
					height: "30px",
			  })
			: jwb === ""
			? setForm1({
					border: "6px solid yellow",
					width: "50px",
					height: "30px",
			  })
			: setForm1({
					border: "6px solid red",
					width: "50px",
					height: "30px",
			  });
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		jwb === "10"
			? setForm2({
					border: "6px solid #1aff66",
					width: "50px",
					height: "30px",
			  })
			: jwb === ""
			? setForm2({
					border: "6px solid yellow",
					width: "50px",
					height: "30px",
			  })
			: setForm2({
					border: "6px solid red",
					width: "50px",
					height: "30px",
			  });
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		jwb === "3500"
			? setForm3({
					border: "6px solid #1aff66",
					width: "70px",
					height: "30px",
			  })
			: jwb === ""
			? setForm3({
					border: "6px solid yellow",
					width: "70px",
					height: "30px",
			  })
			: setForm3({
					border: "6px solid red",
					width: "70px",
					height: "30px",
			  });
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "60") {
			setShow3(true);
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "20") {
			setShow4(true);
			setForm5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2200") {
			setShow5(true);
			setForm6({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setShow1(true);
			setForm7({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "110") {
			setShow2(true);
			setForm8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "X") {
			setShow6(true);
			setForm9({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
				textAlign: "center",
			});
		} else if (jwb === "") {
			setForm9({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm9({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "Y") {
			setShow7(true);
			setForm10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
				textAlign: "center",
			});
		} else if (jwb === "") {
			setForm10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setShow8(true);
			setForm11({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
				textAlign: "center",
			});
		} else if (jwb === "") {
			setForm11({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm11({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "350") {
			setShow9(true);
			setForm12({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
				textAlign: "center",
			});
		} else if (jwb === "") {
			setForm12({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm12({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow10(true);
			setForm13({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
				textAlign: "center",
			});
		} else if (jwb === "") {
			setForm13({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm13({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow11(true);
			setForm14({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
				textAlign: "center",
			});
		} else if (jwb === "") {
			setForm14({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm14({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div>
			<div className="container">
			<div className="d-flex justify-content-end">
			<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
			<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
			</div>
				<div className="row">
					<div className="col-sm-12">
						<p
							style={{
								textIndent: "2rem",
								width: "100%",
								textAlign: "justify",
								lineHeight: "35px",
								fontSize:`${ukuranP}px`
							}}
						>
							Kasus pemrograman linear sangat beragam. Dalam setiap kasus, hal
							yang penting adalah memahami setiap kasus dan memahami konsep
							pemodelannya. Meskipun fungsi tujuan misalnya hanya mempunyai
							kemungkinan bentuk masimisasi atau minimisasi, keputusan untuk
							memilih satu satunya bukan pekerjaan mudah. Tujuan pada suatu
							kasus bisa menjadi batasan pada kasus yang lain. Harus
							berhati-hati dalam menentukan tujuan, koefisien fungsi tujuan,
							batasan, dan koefisien pada fungsi pembatas. Selanjutnya hanya
							akan dibahas model program linear yang memiliki dua variabel
							penentu.
						</p>
					</div>
				</div>
				<div className="d-grid gap-2">
					<div
						onClick={() => clickSetChSoal0()}
						className="btn btn-outline-success btn-sm"
					>
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Contoh Soal
						</h6>
					</div>
				</div>
				<>{chsoal0 ? <Chtambahan ukuranH={ukuranH} ukuranP={ukuranP}/> : null}</>
				<div style={{fontSize:`${ukuranP}px`}} className="text-center">
					Setelah membaca dan memahami contoh soal di atas, selanjutnya kerjakan
					latihan di bawah ini !
				</div>
				<div className="row">
					<div className="col">
						<div
							className="card mt-2 mb-2 border-success"
							style={{ borderRadius: "20px" }}
						>
							<div
								style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
								className="card-header"
							>
								<h6 style={{fontSize:`${ukuranH}px`}} className="text-white text-center">Petunjuk Pengerjaan</h6>
							</div>
							<div className="card-body">
								<ol style={{fontSize:`${ukuranP}px`}}>
									<li>Perhatikan dengan teliti !</li>
									<li>Kalian harus mengisi form yang kosong</li>
									<li>
										Apabila benar maka border form akan berwarna hijau, kemudian
										akan tampil lanjutannya
									</li>
									<li>Apabila salah maka border form akan berwarna merah</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
				<div className="d-grid gap-2">
					<div
						onClick={() => clickSetChSoal1()}
						className="btn btn-outline-success btn-sm"
					>
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 1
						</h6>
					</div>
				</div>
				<div>
					{chsoal1 ? (
						<div>
							<div
								style={{
									margin: "auto",
									lineHeight: "35px",
									textAlign: "justify",
									width: "100%",
									borderStyle: "solid",
									borderColor: "#2d8659",
									borderRadius: "25px",
									boxShadow: "5px 5px #888887",
								}}
								className="mt-2"
							>
								<div
									style={{
										width: "80%",
										margin: "auto",
									}}
								>
									<p
										style={{
											textIndent: "2rem",
											width: "100%",
											textAlign: "justify",
											lineHeight: "35px",
											fontSize : `${ukuranP}px`
										}}
									>
										Andin mempunyai hobi membuat kue. Andin ingin membuat dua
										jenis kue, yaitu jenis A dan jenis B. Untuk membuat kue
										jenis A, diperlukan 50 gram mentega dan 60 gram tepung,
										sedangkan kue jenis B diperlukan 10 gram mentega dan 20 gram
										tepung. Bahan yang tersedia 3,5 kg mentega dan 2,2 kg
										tepung. Buatlah model matematikanya !
									</p>
								</div>
								<div
									style={{
										color: "green",
										display: "flex",
										justifyContent: "space-between",
										width: "10%",
									}}
								>
									<div
										style={{
											width: "5px",
											height: "5px",
											animation: "scrollTop 0.3s alternate ease infinite",
										}}
									>
										<SkipNextIcon />
									</div>
									<p
										style={{ marginLeft: "22px", cursor: "pointer" }}
										onClick={clickSetJawaban1}
									>
										<strong>
											<u>Jawaban</u>
										</strong>
									</p>
									<div
										style={{
											width: "5px",
											height: "5px",
											animation: "scrollTop 0.2s alternate ease infinite",
										}}
									>
										<SkipPreviousIcon />
									</div>
								</div>
								{jawaban1 ? (
									<div
										style={{
											margin: "auto",
											width: "80%",
											position: "relative",
											textAlign: "justify",
										}}
									>
										<ol style={{fontSize:`${ukuranP}px`}}>
											<li>Pertama kita buat tabel, agar memudahkan kita dalam menyusun model matematikanya! </li>
											<MediaQuery minWidth={476} maxWidth={1824}>
												<div>
													<table
														className="table"
														style={{
															border: "2px solid green",
															borderCollapse: "collapse",
															width: "100%",
															textAlign: "center",
														}}
													>
														<tr>
															<th
																scope="col"
																style={{
																	border: "2px solid green",
																}}
															>
																Pembatas
															</th>
															<th
																scope="col"
																style={{
																	border: "2px solid green",
																}}
															>
																Kue A
															</th>
															<th
																scope="col"
																style={{
																	border: "2px solid green",
																}}
															>
																Kue B
															</th>
															<th
																style={{
																	border: "2px solid green",
																}}
															>
																Persediaan
															</th>
															<th
																style={{
																	border: "2px solid green",
																}}
															>
																Satuan
															</th>
														</tr>

														<tr>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																Mentega
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																<input
																	type="text"
																	style={form1}
																	onChange={handleform1}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																<input
																	type="text"
																	style={form2}
																	onChange={handleform2}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																<input
																	type="text"
																	style={form3}
																	onChange={handleform3}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																Gram
															</td>
														</tr>

														<tr>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																Tepung
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																<input
																	type="text"
																	style={form4}
																	onChange={handleform4}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																<input
																	type="text"
																	style={form5}
																	onChange={handleform5}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																<input
																	type="text"
																	style={form6}
																	onChange={handleform6}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																}}
															>
																Gram
															</td>
														</tr>
													</table>
												</div>
											</MediaQuery>
											<MediaQuery maxWidth={475}>
												<Scrollbar style={{ width: "80%", height: 200 }}>
													<div>
														<table
															className="table"
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
																textAlign: "center",
															}}
														>
															<tr>
																<th
																	scope="col"
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Pembatas
																</th>
																<th
																	scope="col"
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Kue A
																</th>
																<th
																	scope="col"
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Kue B
																</th>
																<th
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Persediaan
																</th>
																<th
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Satuan
																</th>
															</tr>

															<tr>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Mentega
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	<input
																		type="text"
																		style={form1}
																		onChange={handleform1}
																	/>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	<input
																		type="text"
																		style={form2}
																		onChange={handleform2}
																	/>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	<input
																		type="text"
																		style={form3}
																		onChange={handleform3}
																	/>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Gram
																</td>
															</tr>

															<tr>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Tepung
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	<input
																		type="text"
																		style={form4}
																		onChange={handleform4}
																	/>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	<input
																		type="text"
																		style={form5}
																		onChange={handleform5}
																	/>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	<input
																		type="text"
																		style={form6}
																		onChange={handleform6}
																	/>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																	}}
																>
																	Gram
																</td>
															</tr>
														</table>
													</div>
												</Scrollbar>
											</MediaQuery>
											{show3 && show4 && show5 ? (
												<div>
													<li>
														<p>Dengan memisalkan :</p>
														<p className="text-center alert alert-warning h6">Isi form di bawah ini sama seperti contoh soal!</p>
														<ul>
														
															<li>
																<input
																	type="text"
																	onChange={handleform9}
																	style={form9}
																/>{" "}
																= banyaknya kue A
															</li>
															<li>
																<input
																	type="text"
																	onChange={handleform10}
																	style={form10}
																/>{" "}
																= banyaknya kue B
															</li>
														</ul>
													</li>
													{show6 && show7 ? (
														<>
															<li>
																<p>Maka,</p>
																<p>Peggunaan mentega :</p>
																<p>
																	<InlineMath math="\iff" />
																	<i>
																		<b>50x + 10y ≤ 3500</b>{" "}
																	</i>
																</p>
																<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
																<p>
																	<InlineMath math="\iff" />
																	<i>
																		<b>
																			<input
																				type="text"
																				style={form11}
																				onChange={handleform11}
																			/>
																			x + y ≤{" "}
																			<input
																				type="text"
																				style={form12}
																				onChange={handleform12}
																			/>{" "}
																		</b>
																	</i>
																</p>
															</li>
															{show8 && show9 ? (
																<>
																		<p className="alert alert-success fst-italic">
																			Dan kalian sudah mendapatkan satu
																			pertidaksamaan
																		</p>
																	<li>
																		<p>Peggunaan tepung :</p>
																		<p>
																			<InlineMath math="\iff" />
																			<i>
																				<b>60x + 20y ≤ 2200 </b>
																			</i>
																		</p>
																		<p><InlineMath math="\iff"/> Disederhanakan menjadi :</p>
																		<p>
																			<InlineMath math="\iff" />
																			<i>
																				<b>
																					<input
																						type="text"
																						style={form7}
																						onChange={handleform7}
																					/>
																					x + y ≤{" "}
																					<input
																						type="text"
																						style={form8}
																						onChange={handleform8}
																					/>{" "}
																				</b>
																			</i>
																		</p>
																	</li>
																	{show1 && show2 ? (
																		<>
																		
																				<p className="alert alert-success fst-italic">
																					Dan kalian sudah mendapatkan dua
																					pertidaksamaan
																				</p>
																			
																			<li>
																				Karena tidak mungkin banyaknya mentega
																				dan tepung yang dimiliki Andin negatif,
																				sehingga dapat dituliskan{" "}
																				<b>
																					<i>
																						x ≥ &nbsp;&nbsp;
																						<input
																							type="text"
																							onChange={handleform13}
																							style={form13}
																						/>{" "}
																					</i>
																				</b>{" "}
																				dan{" "}
																				<b>
																					<i>
																						y ≥ &nbsp;&nbsp;{" "}
																						<input
																							type="text"
																							onChange={handleform14}
																							style={form14}
																						/>{" "}
																					</i>
																				</b>{" "}
																			</li>
																			{show10 && show11 ? (
																				<div>
																					<li>
																						Maka model matematikanya adalah
																					</li>
																					<div className="text-center mt-1">
																						<InlineMath math=" 5x + y ≤ 350 ; " />
																						<InlineMath math=" 3x + y ≤ 110 ; " />
																						<InlineMath math=" x ≥ 0 ; y ≥ 0" />
																					</div>
																				</div>
																			) : null}
																		</>
																	) : null}
																</>
															) : null}
														</>
													) : null}
												</div>
											) : null}
										</ol>
									</div>
								) : null}
							</div>
						</div>
					) : null}
				</div>
				<div className="d-grid gap-2">
					<div
						onClick={() => clickSetChSoal2()}
						className="btn btn-outline-success btn-sm mt-2"
					>
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 2
						</h6>
					</div>
				</div>
				<div>{chsoal2 ? <Ch2 ukuranH={ukuranH} ukuranP={ukuranP} /> : null}</div>
				<div className="d-grid gap-2">
					<div
						onClick={() => clickSetChSoal3()}
						className="btn btn-outline-success btn-sm mt-2"
					>
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 3
						</h6>
					</div>
				</div>
				<div>{chsoal3 ? <Ch3 ukuranH={ukuranH} ukuranP={ukuranP} /> : null}</div>
			</div>
		</div>
	);
};

export default Part3;
